import type { App } from 'vue';
import NotificationHeaderButton from '@src/Notifications/Pages/NotificationHeaderButton.vue';

/**
 * Modular setup — registers the header-slot component the provider adds to
 * app('layout.components') ('header-actions' → 'NotificationHeaderButton').
 */
export function setup(app: App): void {
    app.component('NotificationHeaderButton', NotificationHeaderButton);
}
